import React from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {RemoveDevicesZone} from '../../reduxToolkit/Devices/DevicesApi';
import {toast} from 'react-toastify';
import CustomModal from "../../components/Modal/CustomModal";
import {errorMsg} from "../../Apis/functions";

const RemoveModal = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const uuids = props.data;

    // This section is in charge of remove the respectively items
    const handleDelete = () => {
        dispatch(RemoveDevicesZone(uuids)).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                props.onHide();
                if(success){
                    props.onDelete();
                    toast.success(t('device_removed_success').toUpperCase())
                }else errorMsg(code)
            },
        );
    };
    return (

        <CustomModal
            {...props}
            onHide={props.onHide}
            onConfirm={handleDelete}
            title={props.title_modal_remove}
            size='md'
            buttonConfirm='confirm'
            cancelButton={true}
            classNameBody="pt-2"
        >
            <p className={"d-flex justify-content-center gap-2"}>
                {t('are_you_sure_you_want_to_remove')}
                <span className={"font-color-general-950 ibl-font-w-600"}>{props?.data?.length}</span>
                <span> {t(props.element_modal)}</span>?
            </p>
        </CustomModal>
    );
};

export default RemoveModal;
